module.exports = __webpack_public_path__ + "static/media/gh-3.17ab9bb0.png";